import { FC } from 'react';
import { useSelector } from 'react-redux';

import { State } from 'redux/initialState';

import menuTypes from 'constants/menuTypes';

import MainMenu from 'modules/_shared/components/SideNav/components/MainMenu';
import SecondaryMenu from 'modules/_shared/components/SideNav/components/SecondaryMenu';
import ExtendedMenu from 'modules/_shared/components/SideNav/components/ExtendedMenu';
import ExtendedMenuLoader from 'modules/_shared/components/SideNav/components/ExtendedMenuLoader';
import SideNavTitle from 'modules/_shared/components/SideNav/components/SideNavTitle';

import 'assets/styles/Styles.scss';
import './SideNav.scss';

const SideNav: FC = () => {
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );
  const hasWhiteBranding = useSelector(
    (state: State) =>
      state.society?.actualSociety?.configuration?.hasWhiteBranding
  );
  const showSideNav = useSelector((state: State) => state.sideNav);
  const menu = useSelector((state: State) => state.menu);
  const user = useSelector((state: State) => state.user);

  return (
    menu?.type && (
      <div
        id="main-sidebar"
        className={
          showSideNav
            ? 'nk-aside toggle-screen-lg mobile-menu content-active'
            : 'nk-aside toggle-screen-lg mobile-menu'
        }
        data-content="sideNav"
        data-toggle-overlay="true"
        data-toggle-screen="lg"
        data-toggle-body="true"
      >
        <div className="nk-sidebar-menu" data-simplebar>
          <ul className="nk-menu">
            <li className="nk-menu-heading">
              {menu?.type === menuTypes.EXTENDED && !actualSociety ? (
                <p className="placeholder-glow mb-4 text-primary">
                  <span className="placeholder col-11 h-15px" />
                </p>
              ) : (
                <h6 className="overline-title">
                  <SideNavTitle
                    type={menu?.type}
                    societyName={menu?.societyName || ''}
                    societyId={menu?.societyId || ''}
                    user={user}
                  />
                </h6>
              )}
            </li>

            {menu?.type === menuTypes.MAIN && (
              <>{!hasWhiteBranding && <MainMenu />}</>
            )}

            {menu?.type === menuTypes.EXTENDED && (
              <>
                {actualSociety ? (
                  <ExtendedMenu
                    societyId={menu?.societyId || ''}
                    userId={user['_id']}
                  />
                ) : (
                  <ExtendedMenuLoader rows={10} />
                )}
              </>
            )}

            {!hasWhiteBranding && <SecondaryMenu />}
          </ul>
        </div>

        <div className="nk-aside-close">
          <a
            href="/"
            className="toggle"
            aria-label="link"
            data-target="sideNav"
          >
            <em className="icon ni ni-cross" />
          </a>
        </div>
      </div>
    )
  );
};

export default SideNav;
